// auth参数
const authParams = {}

// 读取凭证
export function readCredential() {
  let result
  if (authParams.hasOwnProperty('credential')) {
    result = authParams.credential
    delete authParams.credential
  }
  return result
}

// 读取语言
export function readLanguage() {
  let result
  if (authParams.hasOwnProperty('language')) {
    result = authParams.language
    delete authParams.language
  }
  return result
}

// 读取租户ID
export function readTenantId() {
  let result
  if (authParams.hasOwnProperty('tenantId')) {
    result = authParams.tenantId
    delete authParams.tenantId
  }
  return result
}

// 读取sessionId
export function readSessionId() {
  let result
  if (authParams.hasOwnProperty('sessionId')) {
    result = authParams.sessionId
    delete authParams.sessionId
  }
  return result
}

/**
 * 调整首次载入的url
 */
function adjustFirstUrl() {
  console.log(location.href)
  let url = getRelativeUrl()
  // 对不符合hash模式的路径，做兼容处理
  if (!url.startsWith('/#/')) {
    if (!url.includes('#')) {
      url = '/#' + url
    } else if (url.endsWith('#')) {
      url = '/#' + url.substring(0, url.length - 1)
    } else if (url.endsWith('#/')) {
      url = '/#' + url.substring(0, url.length - 2)
    } else {
      // 去除#前多余的路径并拼接“/”
      const index = url.indexOf('#')
      if (url.substring(index + 1, index + 2) === '/') { // #后面为“/”
        url = '/' + url.substring(index)
      } else {
        url = '/#/' + url.substring(index + 1)
      }
    }
    history.replaceState({}, '', url)
  }
  hideAuthParams(url)
}

/**
 * 获取相对url
 * @returns
 */
function getRelativeUrl() {
  // 绝对URL
  const absoluteUrl = document.location.toString()
  const arr = absoluteUrl.split('//')
  const start = arr[1].indexOf('/')
  if (start > -1) {
    // 相对URL（从start开始截取）
    return arr[1].substring(start)
  }
  return '/'
}

/**
 * 隐藏auth参数
 * @param {String} url
 * @returns
 */
function hideAuthParams(url) {
  const query = getQueryObject(url)
  if (query.credential) {
    authParams.credential = query.credential
    delete query.credential
  }
  if (query.language) {
    authParams.language = query.language
    delete query.language
  }
  if (query.tenantId) {
    authParams.tenantId = query.tenantId
    delete query.tenantId
  }
  if (query.sessionId) {
    authParams.sessionId = query.sessionId
    delete query.sessionId
  }
  const questionIndex = url.lastIndexOf('?')
  if (questionIndex >= 0) {
    let newUrl = url.substring(0, questionIndex)
    const args = []
    for (const key in query) {
      args.push(`${key}=${query[key]}`)
    }
    if (args.length > 0) {
      newUrl += '?' + args.join('&')
    }
    if (newUrl !== url) {
      history.replaceState({}, '', newUrl)
    }
  }
}

/**
 * 获取查询参数
 * @param {String} url
 * @returns
 */
function getQueryObject(url) {
  const obj = {}
  const questionIndex = url.lastIndexOf('?')
  if (questionIndex > 0) {
    const search = url.substring(questionIndex + 1)
    search.replace(/([^&=]+)=([^&=]*)/g, function(rs, $1, $2) {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
  }
  return obj
}

/* 默认执行 */
adjustFirstUrl()
